export default __webpack_public_path__ + "static/media/link.7473d856.svg";